import {Filter} from '../../../core/filter/filter';
import {LocalDate} from '@js-joda/core';

export class WorkdayLogFilter  extends Filter {
  public employeeId?: number;
  public fromDate?: LocalDate;
  public toDate?: LocalDate;
}
